export const isWebkit = () => {
  const ua = navigator.userAgent;
  const reg = /webkit/;
  if (reg.test(ua.toLowerCase())) return true;
  return false;
};

export default {
  isWebkit,
};
